import React, { useState, useEffect } from 'react';

import './styles.css';


import { Link, useHistory } from 'react-router-dom';
import { FaAngleDown, FaAngleUp, FaPen, FaTrash } from 'react-icons/fa';
import UserPhoto from '../../../../../components/UserPhoto';
import accessServices from '../../../../../services/accessServices';

export default function AccessProfileCard(props) {
    const [showMore, setShowMore] = useState(false);
    const history = useHistory();


    async function deleteAccess(id) {
        try {
            // eslint-disable-next-line no-restricted-globals
            if (confirm(`Deseja remover este acesso?`)) {
                const response = await accessServices.deleteAccess(id);
                history.goBack();
            }
        } catch(err) {
            alert("Erro ao deletar acesso.");
        }
    }


    return (
        <div className='access-page-card' id='card-profile'>
            <UserPhoto src={props.accessInfos && props.accessInfos.foto ? props.accessInfos.foto : null}/>
            <div className='access-card-profile-options'>
                <div className='access-card-profile-infos'>
                    <div>
                        <h4><b>{props.accessInfos.nome}</b></h4>
                        {
                            props.accessInfos.user ?
                            <span><p className={props.accessInfos.user.ativo ? "active" : "inactive"}>{props.accessInfos.user.ativo ? "Ativo" : "Inativo"}</p></span>
                            :
                            null
                        }
                    </div>
                    <p><b>ID: </b>{props.accessInfos.id}</p>
                    {
                        showMore ?
                            <>
                                {props.accessInfos.tipo ? <p><b>Tipo: </b>{props.accessInfos.tipo}</p> : []}
                                {props.accessInfos.user && props.accessInfos.user.email ? <p><b>Email: </b>{props.accessInfos.user.email}</p> : []}
                                {/* {props.accessInfos.telefone ? <p><b>Telefone: </b>{props.accessInfos.telefone}</p> : []}
                                {props.accessInfos.cidade ? <p><b>Cidade: </b>{props.accessInfos.cidade}</p> : []}
                                {props.accessInfos.logradouro ? <p><b>Endereço: </b>{props.accessInfos.logradouro}, {props.accessInfos.numero}</p> : []} */}
                            </>
                            : []
                    }
                    <button onClick={() => setShowMore(!showMore)}>
                        {showMore ? "Menos informações" : "Mais informações"} {showMore ? <FaAngleUp /> : <FaAngleDown />}
                    </button>
                </div>

                <div className='access-card-profile-buttons'>
                    <Link className='button' to={`/admin/acessos/${props.accessInfos.id}/editar`}>Editar Acesso<FaPen /></Link>
                                
                    <button className='button access-card-delete' onClick={() => deleteAccess(props.accessInfos.id)}>Excluir Acesso<FaTrash/></button>
                </div>


            </div>
        </div>
    )
}